// Shared typography classes for product detail page content areas.

export const PRODUCT_DETAIL_CONTENT_WRAP = "product-detail-content max-w-none";

export const PRODUCT_DETAIL_BODY_TEXT =
  "text-lg sm:text-xl leading-[2]";
